import { prepareMessages } from '@ci/message/node';

export const m = prepareMessages('accordion', [
	['collapse', 'Collapse'],
	['expand', 'Expand'],
]);
